import React from 'react';
import Label from '../../view/block/label';
import { Typography } from 'antd';
import { format } from 'date-fns';
import { ReactComponent as ArrowRight } from '../../../../../../../@casino/img/right-arrow.svg';
import { ReactComponent as ArrowDown } from '../../../../../../../@casino/img/down-arrow.svg';

const PeriodSinceRegistration = (modifier) => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div>
            <div style={{display: 'flex', columnGap: 12, alignItems: 'center', width: '100%'}}>
                <Typography style={{ color: modifier.validate && !isOpen ? "#79CF5B" : !isOpen ? "#FF403D" :  'hsla(0,0%,100%,.8)', textTransform: 'uppercase', fontSize: 14, fontWeight: 700 }}>Проверка пользователя на дату регистрации</Typography>
                {
                    isOpen && <ArrowDown style={{height: 12, width: 12, fill: '#FFF', cursor: 'pointer'}}  onClick={() => setIsOpen(false)}/>
                }
                {
                    !isOpen && <ArrowRight style={{height: 12, width: 12, fill: '#FFF', cursor: 'pointer'}} onClick={() => setIsOpen(true)}/>
                }
            </div>
            {
                isOpen && (
                    <div>
                        <Label
                            label="Юзер зарегестрирован"
                            description={format(new Date(Number(modifier.current)), 'dd.MM.yyyy HH:mm')}
                            color={modifier.validate ? "#79CF5B" : "#FF403D"}
                        />
                        <Label
                            label="Макс. дата в комиссии"
                            description={format(new Date(Number(modifier.value)), 'dd.MM.yyyy HH:mm')}
                            color={modifier.validate ? "#79CF5B" : "#FF403D"}
                        />
                        <Label
                            label="Статус"
                            description={modifier.validate ? "Модификатор пройден" : "Модификатор не пройден"}
                            color={modifier.validate ? "#79CF5B" : "#FF403D"}
                        />
                    </div>
                )
            }
            
        </div>
    )
}

export default PeriodSinceRegistration;